import {
  call, put, takeLatest, all, select,
} from 'redux-saga/effects';
import moment from 'moment';
import { message as antdMessage, message } from 'antd';

import {
  setEncargosWorkspace, setWorkspaceLoading,
  devolverArticuloDeEncargoSuccess, fetchEncargoAndLoadIntoWorkspace,
} from '../actions/creators/encargos.actioncreator';
import { authRequest } from '../../helpers/request.helper';
import { showInfo, showSuccess, toastDanger } from '../actions/creators/mensajesSistema.actioncreator';

import {
  ENCARGOS_CREAR_PRESUPUESTO_RAPIDO, ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_FAILURE,
  ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_REQUEST, ENCARGOS_OBTENER_ENCARGO_DESDE_SERVIDOR_SUCCESS,
  ENCARGOS_DEVOLVER_ARTICULOS_REQUEST, ENCARGOS_DEVOLVER_ARTICULOS_FAILURE,
  ENCARGOS_DEVOLVER_ARTICULOS_SUCCESS, ENCARGOS_COBRAR_REQUEST, ENCARGOS_COBRAR_SUCCESS, ENCARGOS_COBRAR_FAILURE,
} from '../actions/constants/encargos.constants';
import {
  PEDIDOSLC_OBTENER_PEDIDOS_FAILURE,
  PEDIDOSLC_OBTENER_PEDIDOS_REQUEST,
  PEDIDOSLC_OBTENER_PEDIDOS_SUCCESS,
  PEDIDOSLC_REALIZAR_PEDIDO_FAILURE,
  PEDIDOSLC_REALIZAR_PEDIDO_REQUEST,
  PEDIDOSLC_REALIZAR_PEDIDO_SUCCESS,
} from '../actions/constants/pedidoslc.constants';

const authState = state => state.auth;
function* setWorkspace({
  payload: {
    proveedorId, tiendaId, pagina, limite,
  },
}) {
  try {
    const auth = yield select(authState);
    const { permisos } = auth;
    const data = {
      'pedido.cdgtipo': { operador: 'eq', valor: permisos.configuracion.articulo_lentillas },
      'pedido.cdgproveedor': { operador: 'eq', valor: proveedorId },
      'pedido.estadoId': { operador: 'eq', valor: 1 },
      unidades_pendientes: { operador: 'gt', valor: 0 },
      pedidoLc: { operador: 'virtual' },
    };
    data.cdgsucursal = { operador: 'eq', valor: tiendaId };
    const formData = new FormData();
    formData.append('consulta', JSON.stringify(data));
    formData.append('limite', limite);
    formData.append('pagina', pagina);
    formData.append('orden', JSON.stringify({ 'pedido.fecha_emision': 'DESC' }));
    const params = {
      url: 'api/detalle-pedido/buscar',
      method: 'POST',
      body: formData,
    };
    const {
      datos, total,
    } = yield call(authRequest, params);
    const datosFormateados = datos.map(e => ({
      ...e,
      ...e.pedido,
      ...e.lineaPedidoLc,
      id: `${e.id}_${e.cdglinea}`,
      fecha_emision: moment(e.pedido.fecha_emision?.date).format('DD-MM-YYYY'),
      tipo: 'VENTA',
      pedido: undefined,
      articulo: undefined,
      lineaPedidoLc: undefined,
    }));
    yield put({
      type: PEDIDOSLC_OBTENER_PEDIDOS_SUCCESS,
      payload: {
        datos: datosFormateados, total,
      },
    });
  } catch (error) {
    yield put(setWorkspaceLoading({ loading: false }));
    yield put({ type: PEDIDOSLC_OBTENER_PEDIDOS_FAILURE, payload: error });
  }
}
function* realizarPedido({
  payload: {
    proveedorId, tiendaId,
  },
}) {
  try {
    const formData = new FormData();
    formData.append('proveedorId', proveedorId);
    formData.append('tiendaId', tiendaId);
    // formData.append('tiendaId', tiendaId);
    const params = {
      url: 'api/pedidos/lc/enviar',
      method: 'POST',
      body: formData,
    };
    const respuesta = yield call(authRequest, params);
    yield put({
      type: PEDIDOSLC_REALIZAR_PEDIDO_SUCCESS,
      payload: respuesta,
    });
    message.success(respuesta[0].estado, 3);
  } catch (error) {
    yield put(setWorkspaceLoading({ loading: false }));
    yield put({ type: PEDIDOSLC_REALIZAR_PEDIDO_FAILURE, payload: error });
    message.error(error?.response?.data?.error_message, 5);
  }
}

function* pedidoslcWorkspaceSaga() {
  yield all([
    takeLatest(PEDIDOSLC_OBTENER_PEDIDOS_REQUEST, setWorkspace),
    takeLatest(PEDIDOSLC_REALIZAR_PEDIDO_REQUEST, realizarPedido),
  ]);
}

export default pedidoslcWorkspaceSaga;
